import authHeader from "@/services/headers";

/**
 * Descarga un archivo de la API respetando los headers de autenticacion.
 *
 * Las descargas por navegacion directa (window.location.href / window.open) NO
 * pueden enviar headers, asi que los endpoints protegidos por los middleware de
 * rol (can.reports / can.item) respondian 401 y el navegador pintaba el JSON de
 * error en pantalla. Aca se pide por fetch (con Authorization y X-User-Role) y
 * se guarda el blob resultante.
 *
 * @param {String} url URL absoluta del endpoint que devuelve el archivo.
 * @param {String} filename Nombre con el que se guarda el archivo.
 * @returns {Promise<void>} Resuelve cuando se disparo la descarga; lanza Error con
 *                          el mensaje del backend si la peticion falla.
 */
export default async function downloadFile(url, filename) {
  const response = await fetch(url, { headers: { ...authHeader() } });

  if (!response.ok) {
    let message = `No se pudo generar el archivo (error ${response.status})`;
    try {
      const data = await response.json();
      if (data && data.message) message = data.message;
    } catch (e) {
      // La respuesta de error no traia JSON; se deja el mensaje generico.
    }
    throw new Error(message);
  }

  const blob = await response.blob();

  // Varios endpoints responden 200 con un JSON tipo "No se encontro informacion"
  // en vez del archivo. Sin este chequeo se descargaba un .xlsx corrupto.
  if (blob.type && blob.type.includes("application/json")) {
    const text = await blob.text();
    let message = text;
    try {
      const parsed = JSON.parse(text);
      message = typeof parsed === "string" ? parsed : parsed.message || text;
    } catch (e) {
      // Cuerpo no parseable; se muestra tal cual.
    }
    throw new Error(message);
  }

  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}
